import React, { Component } from 'react';
import Home from '../pages/Home';
import Active from '../pages/reports/Active';
import Efficience from '../pages/reports/Efficience';
import Extent from '../pages/reports/Extent';
import Strategic from '../pages/reports/Strategic';
import Update from '../pages/Update';
import RetrieveMentoringData from '../pages/RetrieveMentoringData';
import Login from '../pages/Login';
import { Switch, Route, Redirect, PropsRoute } from 'react-router-dom'



class Content extends Component {
  constructor(props) {
    super(props);            
    this.handleLogout = this.handleLogout.bind(this);
    this.state = {
      isOpen: false      
    };        
  }
  handleLogout(e) {
    this.props.handleLogout(e);
  }  
  componentDidUpdate(prevProps, nextState) {
    
    
  }
  render() {    
    return (      
      <div>
        <Switch>
          <Route exact path='/' component={Home}/>          
          <Route exact path='/home' component={Home}/>
          <Route exact path='/reports/active' component={Active}/>
          <Route exact path='/reports/efficience' component={Efficience}/>
          <Route exact path='/reports/extent' component={Extent}/>
          <Route exact path='/reports/strategic' component={Strategic}/>
          <Route exact path='/update' component={Update}/>
          <Route exact path='/retrieve-mentoring-data' component={RetrieveMentoringData}/>           
          <Route path='/' component={Home}/>
        </Switch>
      </div>
    )
  }
}

export default Content;



// WEBPACK FOOTER //
// ./src/layout/Content.js